import { render, staticRenderFns } from "./checkInfo.vue?vue&type=template&id=1500ae54"
import script from "./checkInfo.vue?vue&type=script&lang=js"
export * from "./checkInfo.vue?vue&type=script&lang=js"
import style0 from "./checkInfo.vue?vue&type=style&index=0&id=1500ae54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports